import {ReplaySubject} from 'rxjs';

export class MessageHub {
  constructor() {
    this.topics = {};
  }

  /**
   * Subscribes a handler function to messages published under the given topic.
   * @param {string} topic - The topic to subscrube to
   * @param {Function} handler - The function to be called whenever a message is published to the given topic.
   */
  subscribe({topic, handler}) {
    this._validateTopic(topic);
    this._ensureTopic(topic);

    this.topics[topic].subscribe(handler);
  }

  /**
   * Publish a message to the given topic.
   * @param {string} topic - The topic.
   * @param {Object} message - The message to be published.
   */
  publish({topic, message}) {
    this._validateTopic(topic);
    this._ensureTopic(topic);

    this.topics[topic].next(message);
  }

  _validateTopic(topic) {
    if (typeof topic !== 'string') {
      throw new Error('Message topic must be a string!');
    }
  }

  _ensureTopic(topic) {
    if (!this.topics[topic]) {
      this.topics[topic] = new ReplaySubject();
    }
  }
}
